import { autho2, urlSearch } from './zjs'
import store from '../../store'
import bookCategory from './data/bookCategory'
import { isFunction } from 'lodash'
import { completionCourseItem, filterEditionValue } from '../../api/setting'

export { filterEditionValue, completionCourseItem } from '../../api/setting'

// 获取平台书籍的跳转链接
export function getBookHref({ id, category, query = {}, origin = false }) {
  var url = ''
  const textbookDetails = [
    'jiaofu',
    'keben',
    'tingxie',
    'yuedu',
    'zhishidian',
    'jiaofu_answer',
    'keben_answer'
  ]
  const dianDuBooks = ['mingzhuyuedu', 'kebendiandu', 'huibendiandu']
  const holidayBook = ['shujiazuoye', 'hanjiazuoye']
  const cmsSite = ['chuanjiang']
  if (textbookDetails.includes(category)) {
    // 课本·教辅·知识点·听写·阅读
    url = `/cms/webapp/home/answer/index.html?t=0520#/textbookDetails${urlSearch({
      ...query,
      id: id
    })}`
  } else if (cmsSite.includes(category)) {
    // 串讲
    url = autho2(`/cms/upload/site/book/${id}.html`, query)
  } else if (dianDuBooks.includes(category)) {
    // 点读
    url = `/cms/webapp/home/answer/index.html?t=0520#/dianDuBooks${urlSearch({ ...query, id: id })}`
  } else if (category.includes('mijuan')) {
    // 密卷
    url = `/cms/webapp/home/answer/index.html?t=0520#/mjBooks${urlSearch({ ...query, id: id })}`
  } else if (holidayBook.includes(category)) {
    url = `/cms/webapp/home/answer/index.html?t=0520#/holidayBook/pageNumber${urlSearch({
      ...query,
      id: id
    })}`
  } else {
    url = `/cms/webapp/home/answer/index.html?t=0520#/textbookDetails${urlSearch({
      ...query,
      id: id
    })}`
  }
  return `${origin ? window.location.origin : ''}${url}`
}

// 为ossbook数据，转换字典值
export async function transformOssbookDictionary(bookList = [], options = {}) {
  // eslint-disable-next-line object-curly-spacing
  const { valueDealFn = {}, extraField = {} } = options
  const isObj = !(bookList instanceof Array)
  const zidian = {
    version: 'answercard.basicbook.version',
    course: 'answercard.basicbook.course',
    grades: 'answercard.basicbook.grade',
    volume: 'answercard.basicbook.volume'
    // publisher: 'answercard.basicbook.publisher'
    // category: 'answercard.basicbook.category'
  }
  const dictionaryData = await store.dispatch(
    'dictionary/getDictionaryData',
    Object.values(zidian).map((i) => ({ parentId: i, recursiveTimes: 1 }))
  )
  const data = isObj ? [bookList] : bookList
  const joinData = data.map((bookData) => {
    const targetObj = bookData.book ? bookData.book : bookData
    // 字段值特殊处理函数
    const localValueDealFn = {
      grades: (key, grades, dictionary) => {
        const transKey = key + 'Name'
        return {
          transKey,
          transValue: getGradesName(grades, dictionary)
        }
      },
      ...valueDealFn
    }
    // 默认处理函数
    const defaultValueDealFn = (key, value, dictionary) => {
      const targetValue = typeof value === 'object' ? value[0] : value
      const transKey = key + 'Name'
      const transValue = dictionary.find((z) => String(z.value) === String(targetValue)).chName
      return {
        transValue,
        transKey
      }
    }
    // 增加字典值
    Object.keys(zidian).forEach((key) => {
      if (targetObj[key]) {
        const fn = localValueDealFn[key] || defaultValueDealFn
        const { transValue, transKey } = fn(
          key,
          targetObj[key],
          dictionaryData[zidian[key]],
          targetObj
        )
        targetObj[transKey] = transValue
      }
    })
    const extraFieldObj = {
      renderVolumeName: getRenderVolumeName,
      renderTagNameNoCourse: getRenderTagNameNoCourse,
      renderTagName: getRenderTagName,
      renderAllJudgeName: getRenderAllJudgeName,
      ...extraField
    }
    // 其他字段增加
    Object.keys(extraFieldObj).forEach((key) => {
      const val = extraFieldObj[key]
      targetObj[key] = isFunction(val) ? val(targetObj, dictionaryData) : val
    })
    return bookData
  })

  return isObj ? joinData[0] : joinData
}

/**
 *
 关于年级册次的展示规则：适用所有模块

 1.学段：小学(1-6年级)、初中(7-9年级)

 规则1: 选择总年级数<=4，1集中在一个学段且大于两个年级展示学段，2否则展示全部年级。

 规则2: 选择总年级数＞4，展示对应学段，可叠加学段。

 规则3: 单个年级展示单个年级
 * @param {*} grades 年级
 */
export function getGradesName(grades, dictionary) {
  let gradesNameValue = ''
  const chu = grades.filter((i) => Number(i) >= 7).length
  const xiao = grades.filter((i) => Number(i) < 7).length
  const count = chu + xiao
  const str = ['小学', '初中']
  // 展示学段的剪枝判断有两个
  const stageIf1 = count > 4 // 规则2
  const stageIf2 = count > 1 && (!xiao || !chu) && [xiao, chu].some((i) => i > 2) // 规则 1-1
  if ([stageIf1, stageIf2].some(Boolean)) {
    gradesNameValue = [xiao, chu]
      .map((i, index) => (i ? str[index] : ''))
      .filter(Boolean)
      .join('、')
  } else {
    // 从字典中取值
    gradesNameValue =
      grades
        .map((grade) => dictionary.find((z) => String(z.value) === String(grade)).chName)
        .join('、')
        .replace(/年级/g, '') + '年级'
  }
  return gradesNameValue
}

// 获取渲染册次名称，册次规则：选择年级数≥2，隐藏册次，其他情况展示，特殊地，阅读无册次
export function getRenderVolumeName(book, dictionary) {
  if (book.category === 'yuedu') {
    return ''
  }
  const grades = Array.isArray(book.grades) ? book.grades : [book.grades]
  if (grades.length > 1) {
    return ''
  } else {
    return book.volumeName || ''
  }
}

export function getRenderTagNameNoCourse(book) {
  const tagName = book.name || book.abbrName || book.abbr_name || ''
  return tagName
}

// 获取所有判断完整的标签名称，即排除书籍属性后的，name||abbrName
export function getRenderTagName(book, addCourse = true) {
  const tagName = getRenderTagNameNoCourse(book)
  if (addCourse && ['keben', 'kebendiandu'].includes(book.category)) {
    return book.courseName + tagName
  } else {
    return tagName
  }
}

// 获取所有判断完整的全名称
export function getRenderAllJudgeName(book) {
  return (
    (book.versionName || '') +
    (book.courseName || '') +
    (book.gradesName || '') +
    (getRenderVolumeName(book) || '') +
    (getRenderTagName(book, false) || '')
  )
}

// 公共跳转链接
export function getHref(page, options = {}) {
  const allLinks = {
    // 七鱼客服链接
    kefu: '/cms/webapp/home/info/qiyukf-session.html',
    // 领取优惠券链接
    busifavorReecive: (query) => `/cms/webapp/home/vipPay/index.html#/receive${urlSearch(query)}`,
    bookInfo: getBookHref
  }
  return allLinks[page]
}

// 统计类型mopa和cms互转
export function transformCategory(category) {
  if (typeof category === 'string') {
    return (bookCategory.find((i) => i.category.includes(category)) || {}).value || null
  } else {
    return (bookCategory.find((i) => i.value === category) || {}).category || []
  }
}

// 根据用户偏好，图书版本，筛选出最终显示的版本
export function getUserBookVersionName(book, isCate, length) {
  if (!book.id) return ''
  const settingBookVersion = store.state.user.settingBookVersion // 用户选择的版本
  const dicSettingCourses = store.state.dictionary.settingCourses // 当前用户选择的年级下对应的科目和版本
  const dictionary = store.state.dictionary.bookVersionList // 书籍所有的版本
  // const userNotSelectedVersions = settingBookVersion.length === 0 // 用户没有选择版本
  if (dictionary.length === 0) return ''
  let bookVersions = book.versions || [book.version]
  // 书籍是全部版本
  const bookSupportAllVersions = bookVersions.includes(0)
  if (bookSupportAllVersions) {
    bookVersions = dictionary.map((item) => +item.value)
  }
  const cour = completionCourseItem(
    {
      course: book.course,
      versions: bookVersions
    },
    dictionary,
    dicSettingCourses
  )
  const bookVersionsName = cour.versions.map(({ name }) => name)
  // 没有versions字段，按照version字段的单版本进行返回
  if (bookVersions.length === 0) return cour.versions[0].name
  // 判断一本书是否在用户的偏好设置中
  const intersection = filterEditionValue(settingBookVersion, {
    course: book.course,
    versions: bookVersions
  })
  // 当书籍版本>5个,且包含用户选择的版本时, 也算支持全部书籍
  const fakeBookSupportAllVersions = intersection.length === 1 && bookVersions.length > length
  // console.log(
  //   'isCate',
  //   book.course,
  //   bookSupportAllVersions,
  //   intersection,
  //   cour,
  //   bookVersions,
  //   dicSettingCourses,
  //   length
  // )
  if (isCate) {
    // 密卷多版本显示  如果偏好设置里有,则返回偏好设置中的版本
    if (intersection.length >= 1) {
      return intersection[0].name
    } else {
      return bookVersionsName[0] + (bookVersionsName.length > 1 ? '...' : '')
    }
  } else if (length && length < bookVersions.length) {
    if (bookSupportAllVersions || fakeBookSupportAllVersions) return '适用全部版本'
    return `${bookVersionsName.slice(0, length).join('/').substring(0, 21)}...`
  } else if (length) {
    const versionText = bookVersionsName.join('/')
    return versionText.length > 21 ? versionText.substring(0, 21) + '...' : versionText
  } else {
    return intersection.length === 1
      ? intersection[0].name
      : bookVersionsName[0] + (bookVersionsName.length > 1 ? '...' : '')
  }
}

// 获取组合名称
export function getJoinName(data, zidian) {
  // 根据版本id获取版本名称
  const getVersionName = (id) => {
    const res = store.state.dictionary.bookVersionList.find((y) => +id === +y.value)
    if (!res) return ''
    return res.key || res.chName
  }
  zidian.volume = [
    { key: '上册', value: 1 },
    { key: '下册', value: 2 },
    { key: '全一册', value: 3 }
  ]
  let joinName = ''
  const isEq = (t, i) => String(i) === String(t)
  // 科目
  zidian.course.forEach((item) => {
    if (isEq(data.course, item.value)) joinName += item.key || item.chName
  })
  // 年级
  zidian.grade.forEach((item) => {
    if (data.grade) {
      data.grade.forEach((_item) => {
        if (isEq(_item, item.value)) joinName += item.key || item.chName
      })
    }
  })
  // 册次
  zidian.volume.forEach((item) => {
    if (isEq(data.volume, item.value)) joinName += item.key || item.chName
  })
  // 图书名称
  joinName = joinName + (data.abbr_name || data.name)
  // 版本
  // 没有versions字段，按照version字段的单版本进行返回
  if (!data.versions || !data.versions.length) return getVersionName(data.version)
  // 书籍是全部版本
  if (data.versions.includes('0') || data.versions.includes(0)) {
    // 书的版本名称数组
    const bookVersionsList = store.state.dictionary.bookVersionList.map(
      (item) => item.key || item.chName
    )
    joinName += bookVersionsList.join('')
  } else {
    data.versions.forEach((item) => {
      store.state.dictionary.bookVersionList.forEach((y) => {
        if (isEq(item, y.value)) joinName += y.key || y.chName
      })
    })
  }
  return joinName
}
